import React, { useState, useEffect, useCallback } from 'react';
import Swal from 'sweetalert2';

const CertificateSection = () => {
  const [certificates, setCertificates] = useState([]);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [currentCertIndex, setCurrentCertIndex] = useState(0);

   const getCookie = (name) => {
        const cookieString = document.cookie;
        const cookies = cookieString.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.startsWith(name + '=')) {
                return cookie.substring(name.length + 1);
            }
        }
        return null; // Return null if cookie not found
    };

  useEffect(() => {
    const fetchProfileAndCertificates = async () => {
      try {
        const useremail = getCookie('email');
        if (!useremail) {
          console.error("No email found in cookies.");
          return;
        }

        // Step 1: Fetch user profile by email
        const profileRes = await fetch(`https://ethiccraft.org/backend/profile/read_byEmail.php?email=${useremail}`, {
          credentials: 'include',
        });

        if (!profileRes.ok) {
          const errData = await profileRes.json();
          throw new Error(errData.message || "Failed to fetch profile");
        }

        const userData = await profileRes.json();
        const userId = userData.id;

        // Step 2: Fetch certificates by user ID
        const certRes = await fetch(`https://ethiccraft.org/backend/certificates/read_byUserId.php?user_id=${userId}`, {
          credentials: 'include',
        });

        if (!certRes.ok) {
          throw new Error("Failed to fetch certificates");
        }

        const certData = await certRes.json();
        console.log(certData);
        const visibleCertificates = Array.isArray(certData)
        ? certData
            .filter(cert => cert.isShown === "1" || cert.isShown === 1)
            .map(cert => {
              const raw = cert.certificate_path;
              const fixed = raw.replace("/home/ethicraf/public_html/", "");
              console.log("Raw Path:", raw);
              console.log("Fixed Path:", fixed);
              return { ...cert, certificate_path: fixed };
            })
        : [];

        if (visibleCertificates.length === 0) {
          Swal.fire({
            icon: 'info',
            title: 'No Certificates Issued',
            text: 'No certificate has been issued to you till now.',
          });
        }

        setCertificates(visibleCertificates);
      } catch (err) {
        console.error("Error fetching profile or certificates:", err);
        setCertificates([]);
      }
    };

    fetchProfileAndCertificates();
  }, []);

  const openFullscreen = (index) => {
    setCurrentCertIndex(index);
    setIsFullscreen(true);
  };

  const closeFullscreen = useCallback(() => {
    setIsFullscreen(false);
  }, []);

  const nextCertificate = useCallback(() => {
    setCurrentCertIndex((prevIndex) => (prevIndex + 1) % certificates.length);
  }, [certificates.length]);

  const prevCertificate = useCallback(() => {
    setCurrentCertIndex(
      (prevIndex) => (prevIndex - 1 + certificates.length) % certificates.length
    );
  }, [certificates.length]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!isFullscreen) return;

      if (event.key === 'ArrowRight') nextCertificate();
      if (event.key === 'ArrowLeft') prevCertificate();
      if (event.key === 'Escape') closeFullscreen();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isFullscreen, nextCertificate, prevCertificate, closeFullscreen]);

  return (
    <div className="certificate-container">
      <main className="main-certificate-content">
        {certificates.length === 0 ? (
          <h2 className="no-certificates-text">No certificate issued to you till yet.</h2>
        ) : (
          <section className="certificate-grid">
            {certificates.map((cert, index) => (
              <div
                key={cert.id}
                className="certificate-card"
                style={{ animationDelay: `${index * 50}ms` }}
                onClick={() => openFullscreen(index)}
              >
                <div className="card-image-container">
                  <img
                    src={`https://ethiccraft.org/${cert.certificate_path}`}
                    alt= "Certificate"
                    className="certificate-thumbnail"
                    onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/600x400/1e1e2d/ff6347?text=Image+Error'; }}
                  />
                </div>
              </div>
            ))}
          </section>
        )}
      </main>

      {isFullscreen && (
        <div className="fullscreen-modal-overlay" onClick={closeFullscreen}>
          <div className="fullscreen-modal-content" onClick={(e) => e.stopPropagation()}>
            <img
              src={`https://ethiccraft.org/${certificates[currentCertIndex]?.certificate_path}`}
              alt= "Certificate"
              onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/1200x800/1e1e2d/ff6347?text=Display+Error'; }}
            />
            <button className="modal-nav-button left" onClick={prevCertificate}>&larr;</button>
            <button className="modal-nav-button right" onClick={nextCertificate}>&rarr;</button>
            <button className="modal-close-button" onClick={closeFullscreen}>&times;</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CertificateSection;